import { PERSONAL_DATA } from "../../common/constants";
import { GET_REGISTRATION_PAYMENT_LIST_SUCCESS, UPDATE_GENERATED_PAYMENT_REF, UPDATE_FINANCE_OPERATION_DATA } from "../action-types/finance";

const initialState = {
    payments: [],
    generatedPaymentRef: null,
    operation: {
        selectedPaymentMethod: null,
        entity: null,
        nIPC: null,
        nIPCCountry: { code: "Portugal", name: "Portugal" },
        selectedInvoiceData: PERSONAL_DATA
    }
};

const financialReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_REGISTRATION_PAYMENT_LIST_SUCCESS:
            return {
                ...state,
                payments: action.payments.payments
            };
        case UPDATE_GENERATED_PAYMENT_REF:
            return {
                ...state,
                generatedPaymentRef: action.paymentRef
            };
        case UPDATE_FINANCE_OPERATION_DATA:
            return {
                ...state,
                operation: action.operation
            };
        default:
            return state;
    }
}

export default financialReducer;